import cn from 'classnames';
import React from 'react';

import * as localizationKeys from '@/consts/localization/localizationKeys';
import {getLocalizedStrings} from '@/services/localization/localizationService';

import {InfoIcon} from '../../../../../components/Icons';

const FirmwareVersionWarning = ({className}) => {
    const localizedStrings = getLocalizedStrings();
    const title = localizedStrings[localizationKeys.ABOUT_YOUR_DEVICE_FIRMWARE_WARNING_TITLE];
    const description = localizedStrings[localizationKeys.ABOUT_YOUR_DEVICE_FIRMWARE_WARNING_DESCRIPTION];
    const isShowWarning = title || description;

    return (
        isShowWarning && (
            <div
                className={cn(
                    'flex w-full items-start justify-between rounded-xl bg-primary-dark-5 p-4 pr-8',
                    className
                )}
            >
                <div className='flex items-center gap-2 text-start'>
                    <InfoIcon className='shrink-0' />
                    <div>
                        <strong className='mb-0 text-16 leading-15 tracking-02'>{title}</strong>
                        <p className='text-14 leading-143 tracking-04'>{description}</p>
                    </div>
                </div>
            </div>
        )
    );
};

export default FirmwareVersionWarning;
